import { useEffect, useState } from "react"
import { Alert, Box, Button, Card, Heading, Spinner, Stack, Text, VStack } from "@chakra-ui/react"
import { Link as RouterLink } from "react-router"
import PublicContentService from "services/content"

const contentService = new PublicContentService()

function formatDate(value) {
  if (!value) {
    return ""
  }

  try {
    return new Date(value).toLocaleDateString("vi-VN")
  } catch {
    return ""
  }
}

const BlogListPage = () => {
  const [loading, setLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState("")
  const [items, setItems] = useState([])

  useEffect(() => {
    let mounted = true

    const run = async () => {
      setLoading(true)
      setErrorMessage("")

      try {
        const data = await contentService.getLandingPages({
          page: 1,
          page_size: 100,
          keyword: "",
        })

        if (!mounted) {
          return
        }

        const list = Array.isArray(data?.items) ? data.items : []
        setItems(list)
        document.title = "Danh sách bài viết"
      } catch (error) {
        if (!mounted) {
          return
        }

        setItems([])
        setErrorMessage(error?.message || "Không thể tải danh sách bài viết")
      }

      if (mounted) {
        setLoading(false)
      }
    }

    run()

    return () => {
      mounted = false
    }
  }, [])

  return (
    <Box py={3}>
      <VStack align="stretch" gap={4}>
        <Heading size="lg">Bài viết</Heading>

        {loading && (
          <Stack direction="row" align="center" gap={3}>
            <Spinner />
            <Text>Đang tải danh sách bài viết...</Text>
          </Stack>
        )}

        {!!errorMessage && (
          <Alert.Root status="error">
            <Alert.Indicator />
            <Alert.Content>
              <Alert.Title>Không thể tải danh sách bài viết</Alert.Title>
              <Alert.Description>{errorMessage}</Alert.Description>
            </Alert.Content>
          </Alert.Root>
        )}

        {!loading && !errorMessage && items.length === 0 && (
          <Card.Root>
            <Card.Body>
              <Text color="fg.muted">Chưa có bài viết nào.</Text>
            </Card.Body>
          </Card.Root>
        )}

        {!loading && !errorMessage && items.length > 0 && (
          <VStack align="stretch" gap={3}>
            {items.map((item) => {
              const slug = String(item?.slug || "").trim()
              const postLink = slug ? `/blog/${encodeURIComponent(slug)}` : "#"
              const dateText = formatDate(item?.publish_at || item?.update_on)

              return (
                <Card.Root key={String(item?.id || slug || Math.random())}>
                  <Card.Body>
                    <VStack align="stretch" gap={2}>
                      <Heading size="md">{item?.title || "(Chưa có tiêu đề)"}</Heading>
                      {!!dateText && <Text color="fg.muted">Cập nhật: {dateText}</Text>}
                      {!!item?.excerpt && <Text>{item.excerpt}</Text>}
                      <Box>
                        <Button asChild variant="outline" size="sm" disabled={!slug}>
                          <RouterLink to={postLink}>Xem bài viết</RouterLink>
                        </Button>
                      </Box>
                    </VStack>
                  </Card.Body>
                </Card.Root>
              )
            })}
          </VStack>
        )}
      </VStack>
    </Box>
  )
}

export default BlogListPage
